<div id="modal-header" class="modal-header" data-cy="modal-header">
  <div
    id="modal-header-title"
    class="modal-header__title"
    data-cy="modal-header-title"
  >
    <fa-icon
      id="modal-header-title-icon"
      *ngIf="data.titleIcon"
      [icon]="data.titleIcon"
      data-cy="modal-header-icon"
    ></fa-icon>
    <span
      id="modal-header-title-text"
      class="modal-header__title__text"
      data-cy="modal-header-title-text"
      >{{ data.title }}</span
    >
  </div>
  <fa-icon
    id="modal-header-close-icon"
    tabindex="0"
    class="modal-close"
    [icon]="closeIcon"
    (keydown.enter)="dialogRef.close()"
    data-cy="modal-header-close-icon"
    mat-dialog-close
  ></fa-icon>
</div>
<div id="modal-content" class="modal-content" data-cy="modal-content">
  <ng-container *ngComponentOutlet="data.content"></ng-container>
</div>
<div id="modal-footer" class="modal-footer" data-cy="modal-footer">
  <div
    id="modal-footer-special-action"
    class="modal-footer__special-action"
    data-cy="modal-special-action"
  >
    <tux-button
      id="modal-special-action-button"
      *ngIf="data.specialButton"
      type="ghost"
      (clicked)="handleButtonClick(data.specialButton)"
      data-cy="modal-special-action-button"
    >
      {{ data.specialButton.text }}
    </tux-button>
  </div>
  <div id="modal-footer-actions" class="modal-footer__actions">
    <!-- <tux-button
      id="modal-footer-cancel-button"
      type="secondary"
      (clicked)="handleButtonClick(data.cancelButton)"
      data-cy="modal-footer-cancel-button"
      [attr.gainsight-id]="data.cancelButton.gainsightId"
    >
      {{ data.cancelButton.text }}
    </tux-button> -->
    <tux-button
      id="modal-footer-cancel-button"
      type="secondary"
      (clicked)="handleButtonClick(data.cancelButton)"
      data-cy="modal-footer-cancel-button"
    >
      {{ data.cancelButton.text }}
    </tux-button>
    <!-- <tux-button
      id="modal-footer-affirm-button"
      type="primary"
      [attr.gainsight-id]="data.affirmButton.gainsightId"
      [isDanger]="data.affirmButton.isDanger || false"
      (clicked)="handleButtonClick(data.affirmButton)"
      data-cy="modal-footer-affirm-button"
    >
      {{ data.affirmButton.text }}
    </tux-button> -->
    <tux-button
      id="modal-footer-affirm-button"
      type="primary"
      [isDanger]="data.affirmButton.isDanger || false"
      (clicked)="handleButtonClick(data.affirmButton)"
      data-cy="modal-footer-affirm-button"
    >
      {{ data.affirmButton.text }}
    </tux-button>
  </div>
</div>
